import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "¿Cuánto tarda en llegar mi presupuesto?",
    a: "Generalmente enviamos la cotización en menos de 2 horas en horario laboral. Si tu urgencia es alta, la priorizamos automáticamente.",
  },
  {
    q: "¿Por qué os pedimos la matrícula?",
    a: "Con la matrícula identificamos el modelo exacto de tu coche y garantizamos al 100% la compatibilidad de la pieza, evitando errores y devoluciones.",
  },
  {
    q: "¿Puedo devolver la pieza si no me sirve?",
    a: "Sí, dispones de 14 días de desistimiento y sustitución inmediata si la pieza presenta alguna discrepancia con lo presupuestado.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-10 text-center"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-amber mb-4">Dudas frecuentes</p>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl leading-[0.95]">
          Preguntas <span className="text-brand-orange">directas</span>
        </h2>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
      >
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-industrial-700" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display font-bold uppercase tracking-wider text-lg sm:text-xl text-left hover:text-brand-amber hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 text-sm sm:text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
